/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import {useCallback, useContext} from "react";
import {EvaluationContext} from "../context/EvaluationContextProvider";
import {
    calculateParts,
    getNextLine,
    getNodeIdsNearCursor,
    getPreviousLine,
    getRightPosition
} from "../utils/evaluationUtils";

export const useEvaluationLineDeletion = (lineId: string) => {
    const {dispatchEvaluation} = useContext(EvaluationContext);

    return useCallback(() => {
        dispatchEvaluation(prevState => {
            let targetLine = getPreviousLine(prevState, lineId)
            if (!targetLine) {
                targetLine = getNextLine(prevState, lineId)
            }

            if (!targetLine) {
                return {...prevState, lines: [], dirty: true}
            }

            const editor = targetLine.editor
            const cursor = getRightPosition(editor)
            editor.placeCursor(cursor.nodeId, cursor.side)
            editor.focus()

            const parts = calculateParts(targetLine.tree)
            return {
                ...prevState,
                nodeIdsNearCursor: getNodeIdsNearCursor(editor),
                dirty: true,
                focused: true,
                lines: prevState.lines.filter(l => l.id !== lineId),
                activeLine: {lineId: targetLine.id, activePartIndex: parts.length - 1, partsCount: parts.length}
            }
        })
    }, [dispatchEvaluation, lineId])
}